import moment from 'moment'
import { createSelector } from 'reselect'
import { OrganizationIntegrationStatus } from 'src/enums'
import {
  OrganizationIntegrationListModel,
  OrganizationIntegrationListResponse,
} from 'src/models/organizationIntegration.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectOrgIntegrationsListResponsesFromState = (
  state: RootState,
): Record<string, OrganizationIntegrationListResponse> | undefined => {
  return state.data.orgIntegrations.listResponses
}

export const selectOrgIntegrationsListResponsesIsLoadedFromState = (
  state: RootState,
): boolean => {
  return state.data.orgIntegrations.isLoaded
}

export const selectOrgIntegrationsModelsFromState = createSelector(
  [selectOrgIntegrationsListResponsesFromState],
  (integrationsListResponses) =>
    integrationsListResponses !== undefined
      ? Object.values(integrationsListResponses).reduce(
          (acc, curr) => ({
            ...acc,
            [curr.connectedPlatform]: new OrganizationIntegrationListModel(
              curr,
            ),
          }),
          {} as Record<string, OrganizationIntegrationListModel>,
        )
      : undefined,
)

export const selectActiveOrgIntegration = createSelector(
  [selectOrgIntegrationsModelsFromState],
  (orgIntegrations) => {
    return Object.values(orgIntegrations || {}).find(
      (integration) =>
        integration.connectionStatus === OrganizationIntegrationStatus.ACTIVE,
    )
  },
)

export const selectFormattedOrgIntegrationLastSyncDate = createSelector(
  [selectActiveOrgIntegration],
  (orgIntegration) => {
    return orgIntegration !== undefined
      ? moment(orgIntegration.lastSyncDate).format('l')
      : ''
  },
)
